/* Strapbridge — storefront behaviour (vanilla). Real cart + marketing UI. */
(function () {
  'use strict';
  var fakeTotal = 0;

  function popBadges() {
    document.querySelectorAll('[data-sb-cart-count]').forEach(function (b) {
      b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
    });
  }
  function setBadges(n) {
    document.querySelectorAll('[data-sb-cart-count]').forEach(function (b) { b.textContent = n; });
  }
  function bumpBadges() {
    document.querySelectorAll('[data-sb-cart-count]').forEach(function (b) {
      b.textContent = (parseInt(b.textContent, 10) || 0) + 1;
    });
    popBadges();
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBadges(c.item_count); updateShip(c.total_price / 100); })
      .catch(function () {});
  }

  /* Real add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-sb-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-sb-atc]');
    if (!btn || btn.disabled) return;
    var orig = btn.getAttribute('data-label') || btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        refreshCart(); popBadges();
        if (window.sbOpenCart) window.sbOpenCart();
        btn.textContent = 'Added ✓'; btn.classList.add('done');
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('done'); btn.disabled = false; }, 1400);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400);
      });
  });

  /* Placeholder demo add (no real variant) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sb-fake-atc]');
    if (!b || b.disabled) return;
    var orig = b.getAttribute('data-label') || b.textContent;
    bumpBadges();
    fakeTotal += parseFloat(b.getAttribute('data-price')) || 0;
    updateShip(fakeTotal);
    b.textContent = 'Added ✓'; b.classList.add('done');
    setTimeout(function () { b.textContent = orig; b.classList.remove('done'); }, 1400);
  });

  /* Free-shipping progress (legacy homepage widget; #shipFill/#shipTxt elements no longer exist in the theme, so this is inert) */
  function updateShip(total) {
    var f = document.getElementById('shipFill'), t = document.getElementById('shipTxt');
    if (!f || !t) return;
    f.style.width = Math.min(100, (total / 200) * 100) + '%';
    if (total >= 200) { t.textContent = '🎉 You qualify for free shipping!'; }
    else { t.textContent = 'Add AED ' + Math.ceil(200 - total) + ' more for free shipping'; }
  }

  /* Announcement rotator */
  var slides = document.querySelectorAll('.ann-slide'), si = 0;
  if (slides.length > 1) {
    setInterval(function () {
      slides[si].classList.remove('active');
      si = (si + 1) % slides.length;
      slides[si].classList.add('active');
    }, 3500);
  }


  /* Scroll reveal — covers both .rv (homepage) and .sb-fade (collection/product) */
  function revealAll() {
    document.querySelectorAll('.rv, .sb-fade').forEach(function (el) { el.classList.add('on', 'is-in'); });
  }
  var revealEls = document.querySelectorAll('.rv, .sb-fade');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('on', 'is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
    /* safety: ensure everything is visible shortly after load even if observer misses */
    setTimeout(revealAll, 1200);
  } else {
    revealAll();
  }



  /* Exit intent */
  var exShown = false;
  document.addEventListener('mouseleave', function (e) {
    var pop = document.getElementById('exit-pop');
    if (pop && e.clientY < 10 && !exShown) { exShown = true; pop.classList.add('show'); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-exit-close]')) {
      var pop = document.getElementById('exit-pop'); if (pop) pop.classList.remove('show');
    }
  });

  /* Collection sort + filter drawer (collection page) */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sb-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sb-drawer-open]');
    if (opener) {
      e.preventDefault();
      var d = document.querySelector(opener.getAttribute('data-sb-drawer-open'));
      if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    var closer = e.target.closest('[data-sb-drawer-close]');
    if (closer) {
      e.preventDefault();
      var dr = closer.closest('[data-sb-drawer]');
      if (dr) { dr.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  refreshCart();
})();

/* Newsletter success popup — shows "Check your email" after signup */
(function () {
  function show() {
    var d = document.createElement('div');
    d.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:20px';
    d.innerHTML = '<div style="background:#fff;border-radius:20px;max-width:400px;width:100%;padding:36px 26px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:Inter,-apple-system,sans-serif"><div style="font-size:44px">📧</div><h3 style="font-size:23px;font-weight:800;margin:14px 0 8px;color:#1D1D1F">Check your email!</h3><p style="font-size:15px;color:#6E6E73;line-height:1.5;margin:0 0 22px">We will email you first when new straps drop and when we run something special.</p><button type="button" style="background:#1D1D1F;color:#fff;border:none;border-radius:999px;padding:14px 28px;font-size:15px;font-weight:700;cursor:pointer;width:100%">Got it</button></div>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) { if (e.target === d || e.target.tagName === 'BUTTON') d.remove(); });
  }
  function chk() { var k = document.querySelector('.nl-ok'); if (k && getComputedStyle(k).display !== 'none') show(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chk); else chk();
})();


/* Cart drawer + strap upsell */
(function () {
  var drawer = document.getElementById('sb-cart');
  if (!drawer) return;
  var itemsEl = drawer.querySelector('[data-cart-items]');
  var subEl = drawer.querySelector('[data-cart-subtotal]');
  var upsellRow = drawer.querySelector('[data-cart-upsell-row]');
  var upsellCards = upsellRow ? Array.prototype.slice.call(upsellRow.querySelectorAll('[data-cart-upsell-card]')) : [];
  var upsellIndex = 0;
  var upsellVisible = [];
  var fillEl = drawer.querySelector('[data-cart-shipfill]');
  var shipEl = drawer.querySelector('[data-cart-shiptxt]');
  var barEl = drawer.querySelector('.sbcart-ship__bar');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var footEl = drawer.querySelector('[data-cart-foot]');
  var isAr = drawer.getAttribute('data-locale') === 'ar';
  var country = drawer.getAttribute('data-country') || '';
  var gccFlat = ['SA', 'KW', 'BH', 'OM', 'QA'];
  /* UAE ships free on every order: no progress bar. SA/KW etc. keep their AED 350 free-shipping goal. */
  var shipGoal = gccFlat.indexOf(country) > -1 ? 35000 : null;
  var cur = 'AED';
  function m(cents) { var v = cents / 100; return cur + ' ' + (v % 1 === 0 ? v : v.toFixed(2)); }
  function shipCopy(subtotal) {
    if (shipGoal === null) {
      if (country === 'AE') {
        return isAr ? '🇦🇪 شحن مجاني مدرج لكل الطلبات' : '🇦🇪 Free shipping included on every order';
      }
      return isAr ? '🇦🇪 شحن مجاني لكل طلبات الإمارات' : '🇦🇪 Free UAE shipping on every order';
    }
    var goalDisplay = m(shipGoal);
    if (subtotal >= shipGoal) {
      return isAr ? '🎉 لقد حصلت على شحن مجاني!' : '🎉 You’ve unlocked free shipping!';
    }
    var remaining = m(shipGoal - subtotal);
    return isAr
      ? '🇦🇪 أضف ' + remaining + ' أخرى للحصول على شحن مجاني'
      : '🇦🇪 Add ' + remaining + ' more for free shipping';
  }
  function openC() { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; render(); }
  function closeC() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  window.sbOpenCart = openC;
  function render() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cur = c.currency || 'AED';
        document.querySelectorAll('[data-sb-cart-count]').forEach(function (b) { b.textContent = c.item_count; });
        var pct = shipGoal ? Math.min(100, Math.round((c.total_price / shipGoal) * 100)) : 100;
        if (barEl) barEl.style.display = shipGoal ? '' : 'none';
        if (fillEl) fillEl.style.width = pct + '%';
        if (shipEl) shipEl.textContent = shipCopy(c.total_price);
        if (c.item_count === 0) {
          if (emptyEl) emptyEl.style.display = 'block';
          if (footEl) footEl.style.display = 'none';
          if (upsellRow) upsellRow.style.display = 'none';
          if (itemsEl) itemsEl.innerHTML = '';
          return;
        }
        if (emptyEl) emptyEl.style.display = 'none';
        if (footEl) footEl.style.display = 'block';
        var html = '';
        c.items.forEach(function (it) {
          html += '<div class="sbcart-item" data-key="' + it.key + '">'
            + '<div class="sbcart-item__img">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</div>'
            + '<div class="sbcart-item__body"><div class="sbcart-item__title" title="' + it.product_title + '">' + it.product_title + '</div>'
            + (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sbcart-item__opt">' + it.variant_title + '</div>' : '')
            + '<div class="sbcart-item__row"><div class="sbcart-qty"><button type="button" data-qty-dec aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty-inc aria-label="Increase">+</button></div>'
            + '<span class="sbcart-item__price">' + m(it.final_line_price) + '</span></div></div>'
            + '<button type="button" class="sbcart-item__rm" data-rm aria-label="Remove">×</button></div>';
        });
        itemsEl.innerHTML = html;
        if (subEl) subEl.textContent = m(c.total_price);
        updateUpsell(c);
      }).catch(function () {});
  }
  /* Cart-aware upsell: pick a priority-ordered list of candidates from what's already
     rendered server-side (only ever in-stock products), then show exactly ONE at a time.
     Prev/next cycles through that list; it never shows more than one card at once. */
  function updateUpsell(c) {
    if (!upsellRow || !upsellCards.length) return;
    if (!c || c.item_count === 0) { upsellRow.style.display = 'none'; upsellVisible = []; return; }
    var inCart = c.items.map(function (it) { return String(it.variant_id); });
    var types = c.items.map(function (it) { return it.product_type; });
    var hasAdapter = types.indexOf('Adapter') > -1;
    var hasStrap = types.indexOf('WHOOP Strap') > -1;
    var hasBundle = types.indexOf('Bundle') > -1;
    var wanted;
    if (hasAdapter && !hasStrap && !hasBundle) {
      wanted = ['bundle', 'strap'];
    } else if (hasStrap && !hasAdapter && !hasBundle) {
      wanted = ['bundle', 'adapter'];
    } else if (hasBundle) {
      wanted = ['strap', 'duopack'];
    } else {
      wanted = ['strap', 'adapter'];
    }
    var list = [];
    wanted.forEach(function (role) {
      upsellCards.forEach(function (card) {
        if (card.getAttribute('data-role') !== role) return;
        var vid = card.getAttribute('data-variant-id');
        if (inCart.indexOf(vid) > -1) return;
        if (list.indexOf(card) === -1) list.push(card);
      });
    });
    upsellCards.forEach(function (card) { card.style.display = 'none'; });
    upsellVisible = list;
    upsellIndex = 0;
    if (!list.length) { upsellRow.style.display = 'none'; return; }
    upsellRow.style.display = 'block';
    list[0].style.display = 'flex';
  }
  function showUpsell(i) {
    if (!upsellVisible.length) return;
    upsellVisible.forEach(function (card) { card.style.display = 'none'; });
    upsellIndex = (i + upsellVisible.length) % upsellVisible.length;
    upsellVisible[upsellIndex].style.display = 'flex';
  }
  function change(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { render(); }).catch(function () {});
  }
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { closeC(); return; }
    if (e.target.closest('[data-upsell-prev]')) {
      showUpsell(upsellIndex - 1);
      return;
    }
    if (e.target.closest('[data-upsell-next]')) {
      showUpsell(upsellIndex + 1);
      return;
    }
    var addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) {
      var card = addBtn.closest('[data-cart-upsell-card]');
      var vid = card && card.getAttribute('data-variant-id');
      if (vid && !addBtn.disabled) {
        addBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            addBtn.classList.add('done');
            render();
          })
          .catch(function () {
            addBtn.disabled = false;
          });
      }
      return;
    }
    var item = e.target.closest('.sbcart-item');
    if (item) {
      var key = item.getAttribute('data-key');
      var q = parseInt(item.querySelector('.sbcart-qty span').textContent, 10) || 1;
      if (e.target.closest('[data-qty-inc]')) change(key, q + 1);
      else if (e.target.closest('[data-qty-dec]')) change(key, Math.max(0, q - 1));
      else if (e.target.closest('[data-rm]')) change(key, 0);
    }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-open]');
    if (b) { e.preventDefault(); openC(); }
  });
})();
